import React, { useState } from "react";
import { Panel } from "primereact/panel";
// @ts-ignore
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// @ts-ignore
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";
import {Button} from "primereact/button";

const CodePanel = ({
                       title,
                       code,
                       language = "javascript",
                   }: {
                        title: string;
                        code: string | null;
                        language?: string;
                    }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(!code ? "" : code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const headerTemplate = (options: { className: any; }) => {
        const className = `${options.className} justify-content-space-between`;

        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                    <span className="font-bold">{title}</span>
                </div>
                <div>
                    <Button
                        icon="pi pi-code"
                        label="Copy"
                        onClick={copyToClipboard}
                    />
                </div>
            </div>
        );
    };

    return (
        <Panel header={title} headerTemplate={headerTemplate}>
            <div className="code-panel-container">
                <SyntaxHighlighter
                    language={language}
                    style={dracula}
                    wrapLongLines
                    customStyle={{
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all',
                        overflowX: 'auto',
                    }}
                    codeTagProps={{
                        style: {
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all',
                        },
                    }}
                >
                    {code}
                </SyntaxHighlighter>
            </div>
        </Panel>
    );
};

export default CodePanel;
